import { gql } from '@nerdwallet/apollo';

export default gql`
  query UrlRecordByUrl($url: URL!, $size: MediaItemImageSizeEnum!) {
    urlRecordByUrl(url: $url) {
      primaryContent
      title
      synopsis
      modified
      date
      url
      authors {
        name
        twitter
      }
      featuredMedia {
        sourceUrl
        croppedImage(size: $size) {
          sourceUrl
        }
      }
      seo {
        description
        title
        keyword
        twitter {
          description
          title
        }
      }
    }
  }
`;
